module.exports = __webpack_public_path__ + "img/erhversstyrrelsen-image-min.1867fbc5.jpg";